var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"home-container"},[_c('Hero'),_c('About'),_c('Models')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }